<template>
  <div class="category-page">
    <div class="page-body">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <router-link to="/">{{ $t('view.common.home') }}</router-link>
        <span class="bc-sep">/</span>
        <span class="current">{{ category ? category.name : $t('view.common.category') }}</span>
      </div>

      <div class="category-header" v-if="category">
        <div class="cat-icon" :class="`cat-bg-${category.id % 5}`">
          <i :class="catIcons[category.id % catIcons.length]" />
        </div>
        <div class="cat-info">
          <h1 class="category-title">{{ category.name }}</h1>
          <p class="category-desc">{{ category.description || $t('view.category.defaultDesc') }}</p>
          <div class="category-meta">
            <span class="meta-count"><strong>{{ tools.length }}</strong> {{ $t('view.category.countUnit') }}</span>
          </div>
        </div>
      </div>

      <div class="tools-section">
        <div v-if="tools.length" class="tool-grid">
          <template v-for="(item, idx) in mixedTools">
            <AdCard v-if="item._ad" :key="'a'+idx" :ad="item" />
            <ToolCard v-else :key="item.id" :tool="item" />
          </template>
        </div>
        <el-empty v-else :description="$t('view.category.empty')" />
      </div>
    </div>
  </div>
</template>

<script>
import ToolCard from '@/components/ToolCard'
import AdCard from '@/components/tool-components/AdCard'
import { getCategoryList, getToolsByCategory, getActiveAds } from '@/api/site'

function setMeta(name, content) {
  if (!content) return
  var el = document.querySelector('meta[name="' + name + '"]')
  if (!el) {
    el = document.createElement('meta'); el.name = name
    document.head.appendChild(el)
  }
  el.content = content
}

export default {
  components: { ToolCard, AdCard },
  created() { this.loadData() },
  data() {
    return {
      category: null,
      tools: [],
      ads: [],
      catIcons: ['el-icon-document', 'el-icon-connection', 'el-icon-s-code', 'el-icon-magic-stick', 'el-icon-brush']
    }
  },
  computed: {
    mixedTools() {
      if (!this.ads.length) return this.tools
      const r = []; let ai = 0
      for (let i = 0; i < this.tools.length; i++) {
        r.push(this.tools[i])
        if ((i + 1) % 4 === 0 && ai < this.ads.length) {
          r.push(this.ads[ai++])
        }
      }
      return r
    }
  },
  methods: {
    loadData() {
      const slug = this.$route.params.slug
      getCategoryList().then(res => {
        const cats = res.data || []
        this.category = cats.find(c => c.slug === slug) || null
        if (this.category) {
          // SEO: dynamic title & meta
          document.title = this.category.seoTitle || (this.category.name + this.$t('view.category.docTitleSuffix'))
          setMeta('description', this.category.seoDesc || this.category.description || '')
          setMeta('keywords', this.category.seoKeywords || '')
          getToolsByCategory(this.category.id).then(r => {
            this.tools = r.data || []
          })
        }
      })
      getActiveAds('category').then(res => {
        this.ads = (res.data || []).map(a => { a._ad = true; return a })
      }).catch(() => { this.ads = [] })
    }
  },
  watch: {
    '$route.params.slug'() { this.loadData() }
  }
}
</script>

<style scoped>
.category-page { background: #f0f2f8; min-height: 100vh; }
.page-body { max-width: 1200px; margin: 0 auto; padding: 28px 20px 60px; }

/* breadcrumb */
.breadcrumb { font-size: 13px; color: #8892a6; margin-bottom: 20px; display: flex; align-items: center; gap: 6px; }
.breadcrumb a { color: #4e7cff; }
.bc-sep { color: #c0c4cc; }
.current { color: #1a1f36; font-weight: 600; }

/* header */
.category-header {
  background: #fff; border-radius: 16px; padding: 32px 36px;
  margin-bottom: 24px; border: 1px solid #e8eaef;
  display: flex; align-items: center; gap: 24px;
}
.cat-icon {
  width: 64px; height: 64px; border-radius: 20px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}
.cat-icon i { font-size: 30px; color: #fff; }
.cat-bg-0 { background: linear-gradient(135deg, #667eea, #764ba2); }
.cat-bg-1 { background: linear-gradient(135deg, #4facfe, #00f2fe); }
.cat-bg-2 { background: linear-gradient(135deg, #43e97b, #38f9d7); }
.cat-bg-3 { background: linear-gradient(135deg, #fa709a, #fee140); }
.cat-bg-4 { background: linear-gradient(135deg, #a18cd1, #fbc2eb); }
.cat-info { flex: 1; min-width: 0; }
.category-title { font-size: 28px; font-weight: 800; color: #1a1f36; margin: 0 0 6px; }
.category-desc { font-size: 14px; color: #606266; margin: 0 0 10px; line-height: 1.5; }
.category-meta { display: flex; align-items: center; gap: 16px; }
.meta-count { font-size: 13px; color: #8892a6; }
.meta-count strong { color: #4e7cff; font-size: 18px; margin-right: 2px; }

/* tools */
.tool-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 18px; }
@media (max-width: 1024px) { .tool-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 768px) { .tool-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 480px) {
  .tool-grid { grid-template-columns: 1fr; }
  .category-header { flex-direction: column; text-align: center; padding: 24px; }
}
</style>
